export default "__VITE_ASSET__B8nv7JU2__"